export default __webpack_public_path__ + "static/media/Premios IMPULSO Sume- Torre Cervantes 251.ee1d233e.pdf";